let serverURL = "";
let wechatREDITECT = ''
let myserve = window.location.origin.split("//")[1];
if (myserve.split(":")[0] == "localhost") {
  serverURL = "https://dt.dev.gyycbj.com/api/";
  wechatREDITECT = "https://dt.gyycbj.com/jctx-web";
} else {
  serverURL = window.location.origin + "/api/";
  wechatREDITECT = window.location.origin + "/jctx-web/";
}
//服务器地址
export const SERVERURL = serverURL
//微信授权地址
export const WECHATAUTH = 'https://uc.gyycbj.com/api/wechat/oauth'
//微信授权回调地址 https://dt.gyycbj.com/jctx-web
export const WECHATREDITECT = wechatREDITECT
//视频资源根路径
export const aliyunURL = 'https://gyycvod.yythealth.com/' //视频资源根路径

